// extracted by mini-css-extract-plugin
module.exports = {"root":"SignupButton-module--root--1Y5Pg","btn":"SignupButton-module--btn--18a9J","subtitle":"SignupButton-module--subtitle--22OyQ"};